import { FC } from 'react';

import { Icon as IconifyIcon } from '@iconify/react';

type IconSizeName = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type IconSize = IconSizeName | number;

interface IconProps {
  icon: string;
  className?: string;
  size?: IconSize;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  'aria-hidden'?: boolean;
  'aria-label'?: string;
}

const getIconSize = (size: IconSize): { width: string | number; height: string | number } => {
  const sizeMap: Record<IconSizeName, string> = {
    xs: '16',
    sm: '24',
    md: '32',
    lg: '48',
    xl: '64',
  };

  if (typeof size === 'number') {
    return { width: size, height: size };
  }

  return { width: sizeMap[size], height: sizeMap[size] };
};

const Icon: FC<IconProps> = ({
  icon,
  className = '',
  size,
  width,
  height,
  style,
  'aria-hidden': ariaHidden = false,
  'aria-label': ariaLabel,
}) => {
  const dimensions = size ? getIconSize(size) : { width, height };

  return (
    <IconifyIcon
      icon={icon}
      className={className}
      width={dimensions.width}
      height={dimensions.height}
      style={style}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
    />
  );
};

export default Icon;
